import React from "react";

import Tabs from "./Tabs";
export const Dashboard = () => {
  return (
    <>
      <Tabs />
    </>
  );
};
